import { router } from 'expo-router';
import { StyleSheet } from 'react-native';
import { View } from 'react-native';

import { Button, IconQrScan, IconStore, Text, tokens } from '@fhs/ui';
import { routes } from '@fhs-legacy/frontend/src/utils/routing';

export function InStoreCard() {
  const onPressScan = () => {
    // @TODO: Add new in store route
    router.navigate(routes.redeem);
  };

  return (
    <View style={styles.container}>
      <View style={styles.iconContainer}>
        <IconStore size={24} />
      </View>
      <View style={styles.textContainer}>
        <Text.Ui size="md" weight="semibold">
          Are You in Restaurant?
        </Text.Ui>
        <Text.Ui size="sm">Scan to earn or redeem</Text.Ui>
      </View>
      <Button type="outline" onPress={onPressScan}>
        <Button.Icon>
          <IconQrScan />
        </Button.Icon>
        <Button.Text>Scan</Button.Text>
      </Button>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 16,
    gap: 12,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: tokens.colors.$blackOpacity10,
    marginTop: 12,
  },
  iconContainer: {
    padding: 8,
    borderRadius: 100,
    backgroundColor: tokens.colors.$blackOpacity04,
  },
  textContainer: {
    flex: 1,
  },
});
